import { makeStyles } from "@mui/styles";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import React from "react";
import { useSelector } from "react-redux";
import { selectUserSession } from "../slices/userSession/userSessionSlice";
import { TIME_OFF_PAGE_TYPE, TRADE_PAGE_TYPE } from "../util/constants";
import { getUnionContractGivenJobCode } from "../util/workgroupMapper.js";
import PropTypes from "prop-types";
import {
  isLWOPTOWOPAllDayRequest,
  isLWOPTOWOPRequest,
  TOR_SUBMISSION_CUTOFF_TIME_REMINDER,
} from "../util/timeOffRequestUtils";
import { TRADE_SUBMISSION_CUTOFF_TIME_REMINDER } from "../util/tradeUtils";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    margin: "auto",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
}));

const UnionContractCutoffTimeReminder = (props) => {
  const userSession = useSelector(selectUserSession);
  const classes = useStyles();

  const renderUnionContractWarning = () => {
    switch (props.pageType) {
      case TRADE_PAGE_TYPE:
        return (
          <Alert severity="warning">
            <AlertTitle>
              <strong>
                {
                  TRADE_SUBMISSION_CUTOFF_TIME_REMINDER[getUnionContractGivenJobCode(userSession.jobCode)]
                    .warningContent.header
                }
              </strong>
            </AlertTitle>
            {
              TRADE_SUBMISSION_CUTOFF_TIME_REMINDER[getUnionContractGivenJobCode(userSession.jobCode)].warningContent
                .message
            }
          </Alert>
        );
      case TIME_OFF_PAGE_TYPE:
        if (isLWOPTOWOPRequest(props.timeOffType)) {
          if (isLWOPTOWOPAllDayRequest(props.timeOffType) && !props.isTimeOffRequestCancelAction) {
            return (
              <Alert severity="warning">
                <AlertTitle>
                  <strong>
                    {
                      TOR_SUBMISSION_CUTOFF_TIME_REMINDER[getUnionContractGivenJobCode(userSession.jobCode)][
                        props.timeOffType
                      ].warningContent["header"]
                    }
                  </strong>
                </AlertTitle>
                {
                  TOR_SUBMISSION_CUTOFF_TIME_REMINDER[getUnionContractGivenJobCode(userSession.jobCode)][
                    props.timeOffType
                  ].warningContent["message"]
                }
              </Alert>
            );
          } else return <></>;
        }
        return (
          <Alert severity="warning">
            <AlertTitle>
              <strong>
                {
                  TOR_SUBMISSION_CUTOFF_TIME_REMINDER[getUnionContractGivenJobCode(userSession.jobCode)][
                    props.timeOffType
                  ].warningContent[props.isTimeOffRequestCancelAction ? "cancelHeader" : "header"]
                }
              </strong>
            </AlertTitle>
            {
              TOR_SUBMISSION_CUTOFF_TIME_REMINDER[getUnionContractGivenJobCode(userSession.jobCode)][props.timeOffType]
                .warningContent[props.isTimeOffRequestCancelAction ? "cancelMessage" : "message"]
            }
          </Alert>
        );
      default:
        return "Missing Page Type, check UnionContractCutoffTimeReminder.jsx";
    }
  };

  return (
    <div className={classes.root} data-testid="union-contract-cutoff-time-reminder">
      {renderUnionContractWarning()}
    </div>
  );
};

UnionContractCutoffTimeReminder.propTypes = {
  pageType: PropTypes.string.isRequired,
  // TIME_OFF Page Type only props
  timeOffType: PropTypes.string,
  isTimeOffRequestCancelAction: PropTypes.bool,
};

UnionContractCutoffTimeReminder.defaultProps = {
  isTimeOffRequestCancelAction: false,
};

export default UnionContractCutoffTimeReminder;
